var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgThumbUp = function SvgThumbUp(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 20,
    height: 20,
    fill: "none"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    stroke: "currentColor",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.4,
    clipPath: "url(#clip0_3063_11153)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M5 12.5h-.833a.833.833 0 0 0-.834.833v2.5c0 .46.373.834.834.834H5c.46 0 .833-.373.833-.834v-2.5A.833.833 0 0 0 5 12.5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M5.833 15.833a.833.833 0 0 0 .834.834h3.13a.83.83 0 0 0 .798-.594l1-2.5c.075-.253.11-.525-.047-.737-.156-.212-.451-.336-.715-.336H9.167v-2.056a.917.917 0 0 0-1.68-.508L5.833 12.5zM11.667 3.333v3.334a.833.833 0 0 0 .833.833h3.333"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M5 8.333V4.815c0-.393.176-.77.488-1.048a1.78 1.78 0 0 1 1.179-.434H12.5l4.167 3.704v8.148c0 .393-.176.77-.489 1.048a1.78 1.78 0 0 1-1.178.434h-1.25"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_3063_11153"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M0 0h20v20H0z"
  })))));
};
export default SvgThumbUp;